module.exports = __webpack_public_path__ + "img/tag_gk@2x.41494eb6.svg";